import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const OpenCollectionIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M13 9.5a1 1 0 1 0-2 0V11H9.5a1 1 0 1 0 0 2H11v1.5a1 1 0 1 0 2 0V13h1.5a1 1 0 1 0 0-2H13V9.5ZM2.5 9A1.5 1.5 0 0 0 1 10.5v3A1.5 1.5 0 0 0 2.5 15h3A1.5 1.5 0 0 0 7 13.5v-3A1.5 1.5 0 0 0 5.5 9h-3ZM2.5 1A1.5 1.5 0 0 0 1 2.5v3A1.5 1.5 0 0 0 2.5 7h3A1.5 1.5 0 0 0 7 5.5v-3A1.5 1.5 0 0 0 5.5 1h-3ZM9 2.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3Z", fill: "currentColor" })));
});
OpenCollectionIcon.displayName = 'OpenCollectionIcon';
export default OpenCollectionIcon;
